import { useSelector } from "react-redux";
import { isPristine } from "redux-form";
import { noop } from "utils/common";

/**
 * Returns a function that confirms that the user wants to cancel editing a modified redux-form
 * @param {string} formName The name of the form to check for modified values
 * @param {function} onClose The function to execute if the user confirms that they want to exit
 * @param {string} [confirmationMessage] The message to display to the user to confirm they want to exit
 * @param {function} [pristineSelector] A selector function that returns a truthy value if the form doesn't need confirmation to close
 *  If pristineSelector isn't provided, defaults to redux-form's `isPristine(formName)`
 * @returns {function} A callback function suitable to pass as a Rhombus Modal's `onClose` prop
 */
export default function useConfirmClose(
	formName,
	onClose = noop,
	confirmationMessage = "Are you sure you want to cancel?  All data entered will be lost.",
	pristineSelector
){
	const formIsPristine = useSelector(pristineSelector || isPristine(formName));

	return function(){
		if(formIsPristine || window.confirm(confirmationMessage)){
			onClose();
		}
	};
}
